import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

const words = [
  { hu: "kutya", ru: "собака" },
  { hu: "macska", ru: "кот" },
  { hu: "ház", ru: "дом" },
  { hu: "kenyér", ru: "хлеб" },
  { hu: "víz", ru: "вода" }
];

const Hungarian = () => {
  // sounds
  const correctSound = new Audio("/sound1.mp3");
  const incorrectSound = new Audio("/sound2.mp3");

  const [index, setIndex] = useState(0);
  const [x, setX] = useState(0);

  const animationRef = useRef(null);

  // current word
  const current = words[index];

  const shuffledRussianWords = useMemo(() => {
    return words.map(w => w.ru).sort(() => Math.random() - 0.5);
  }, []);

  // Pick 3 options for each word, but WITHOUT reshuffling every frame
  const russianChoices = useMemo(() => {
    const choices = shuffledRussianWords.slice(0, 3);
    if (!choices.includes(current.ru)) {
      choices[0] = current.ru;
    }
    return choices.sort(() => Math.random() - 0.5);
  }, [current.ru, shuffledRussianWords]);


  // animate flying word
  useEffect(() => {
    let start = null;
    const speed = 0.15; // px per ms
    const center = window.innerWidth / 2 - 100;

    const animate = (timestamp) =>
    {
      if (!start) start = timestamp;

      const progress = timestamp - start;
      const newX = progress * speed;

      if (newX < center) {
        setX(newX);
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setX(center);
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, [index]);

  const stopAllSounds = () => {
    correctSound.pause();
    correctSound.currentTime = 0;
  
    incorrectSound.pause();
    incorrectSound.currentTime = 0;
  };

  const checkAnswer = (answer) => {
    stopAllSounds();
    if (answer === current.ru) {
      correctSound.play();
      setX(0);

      // next word
      setIndex((i) => (i + 1) % words.length);
    } else {
      incorrectSound.play();
    }
  };

  return (
    <div>
        <Helmet>
          <title>Hungarian Learning | .rq Lab</title>
          <meta
            name="description"
            content="Interactive Hungarian vocabulary practice with quick-choice translations and lightweight game mechanics."
          />
          <link rel="canonical" href="https://roamingquark.info/hungarian" />
        </Helmet>
        <h2>Hungarian learning</h2>

    <div
      style={{
        width: "100%",
        height: "200px",
        position: "relative",
        userSelect: "none",
        fontFamily: "sans-serif"
      }}
    >

      {/* Flying word */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: x,
          fontSize: "32px",
          fontWeight: "bold",
          transition: "left 0.01s linear"
        }}
      >
        {current.hu}
      </div>

      {/* Russian options */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: "20px"
        }}
      >
        {russianChoices.map((ru, idx) => (
          <button
            key={idx}
            onClick={() => checkAnswer(ru)}
            style={{
              padding: "10px 20px",
              fontSize: "20px",
              cursor: "pointer"
            }}
          >
            {ru}
          </button>
        ))}
      </div>
    </div>
    </div>
  )
}

export default Hungarian;
